import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { 
  modalWrap,
  pannelWrap,logHistoryWrap,jsonViewerWrap,
  logItemWrap,logItem,
} from './style.css'
import { Modal,Checkbox } from 'bee'
import "bee-modal/build/Modal.css"
import "bee-checkbox/build/Checkbox.css"

import { requestGet,transferDate } from '../helper/helper'
import noLog from 'assets/img/nodata3.png'
import JsonViewer from '../zTestJson';
import { SingleJsonViewer } from '../zTestJson';

import Loading from '../logComponent/loading'

const LOG_NUM_PAGE = 10;
export default class LogHistoryPannel extends Component {
  static defaultProps = {
    showHistory:false
  }
  constructor(props){
    super(props)
    this.state={
      pannel:props.showHistory,
      showSingleJsonViewer:false,//是否展示单json页面
      singleJsonIndex:-1,//单json index
      showJsonViewer:false,//是否json对比页面
      historyInfo:[],
      compareIndex:[],//待比较历史记录index
      currenrtPage:1,
      totalPage:1,
      isLoading:false,
    }
  }
  shouldComponentUpdate(nextProps,nextState){
    if(!this.props.showHistory){
      return false
    }
    return true
  }
  componentWillMount(){
    this.setState({
      pannel:this.props.showHistory,
    })
    if(!this.props.showHistory)return
    let { busiObjId='',busiObjCode='',busiObjTypeCode='',record } = this.props
    let requestUrl = this.props.url || ((window._YMSHOST_ || "") + '/iuap-apcom-auditlog/diwork-log/business/search/history')
    if(!busiObjId){
      let historyInfoItem = {
        operCode:record.operCode,
        operationDate:record.operationDate,
        operatorName:record.operatorName,
        differentMsg:record.detail,
        newBusiObj:record.newBusiObj
      }
      this.setState({
        historyInfo:[historyInfoItem],
        currenrtPage:1,
        totalPage:1,
      })
      return 
    }
    this.setState({
      isLoading:true
    })
    requestGet(requestUrl,{busiObjId,busiObjCode,busiObjTypeCode}).then( res =>{
      let { data =[] } = res
      let historyInfo = data,
          currenrtPage = 1,
          totalPage = Math.ceil(data.length/LOG_NUM_PAGE);
      totalPage = totalPage==0?1:totalPage;
      this.setState({
        historyInfo,
        currenrtPage,
        totalPage,
        isLoading:false
      })
    }).catch(err => {
      this.setState({
        isLoading:false
      })
    })
  }
  componentWillReceiveProps(nextProps){
    this.setState({
      pannel:nextProps.showHistory,
    })
    if(!nextProps.showHistory)return
    let { busiObjId='',busiObjCode='',busiObjTypeCode='',record } = this.props
    if(!busiObjId){
      let historyInfoItem = {
        operCode:record.operCode,
        operationDate:record.operationDate,
        operatorName:record.operatorName,
        differentMsg:record.detail,
        newBusiObj:record.newBusiObj
      }
      this.setState({
        historyInfo:[historyInfoItem],
        currenrtPage:1,
        totalPage:1,
      })
      return 
    }
    this.setState({
      isLoading:true
    })
    let requestUrl = nextProps.url || ((window._YMSHOST_ || "") + '/iuap-apcom-auditlog/diwork-log/business/search/history')
    requestGet(requestUrl,{busiObjId,busiObjCode,busiObjTypeCode}).then( res =>{
      let { data =[] } = res
      let historyInfo = data,
          currenrtPage = 1,
          totalPage = Math.ceil(data.length/LOG_NUM_PAGE);
      totalPage = totalPage==0?1:totalPage;
      this.setState({
        historyInfo,
        currenrtPage,
        totalPage,
        isLoading:false
      })
    }).catch(err => {
      this.setState({
        isLoading:false
      })
    })
  }
  togglePannel = ()=>{
    this.setState({
      showJsonViewer:!this.state.showJsonViewer,
    })
  }
  chooseToSpread = (index,e) =>{
    e.stopPropagation()
    this.setState({
      singleJsonIndex:index,
      showSingleJsonViewer:true,
    })
  }
  close = ()=>{
    if(this.state.showJsonViewer){
      this.togglePannel()
      return
    }
    if(this.state.showSingleJsonViewer){
      this.setState({
        singleJsonIndex:-1,
        showSingleJsonViewer:false,
      })
      return
    }
    this.setState({
      // pannel:false,
      showJsonViewer:false,
      historyInfo:[],
      compareIndex:[],//待比较历史记录index
      currenrtPage:1,
      totalPage:1,
      pannel:false
    })
    //this.props.closePannel()
  }
  expandContent = e => {
    if(e.target.nodeName === 'SPAN'){
      e.target.parentNode.classList.toggle('active')
      return 
    }
    e.target.classList.toggle('active')
  }

  chooseToCompare = index => {
    let { compareIndex } = this.state;
    if(compareIndex.indexOf(index)>-1){
      //当前节点已经被选中
      let currentIndex = compareIndex.indexOf(index)
      compareIndex.splice(currentIndex,1)
      this.setState({
        compareIndex,
      })
      return
    }
    compareIndex.push(index)
    compareIndex = compareIndex.slice(-2)
    this.setState({
      compareIndex,
    })
  }
  getMoreLog = ()=>{
    let { currenrtPage,totalPage } = this.state
    if(currenrtPage<totalPage){
      this.setState({
        currenrtPage:currenrtPage+1
      })
    }else{
      return
    }
    // requestGet('/diwork-log/business/logdata',{page:currenrtPage+1}).then( res =>{
    //   let { historyInfo,totalPage } = this.state
    //   if( res.page == currenrtPage+1 ){
    //     historyInfo = historyInfo.concat(res.data)
    //     currenrtPage = res.page
    //     totalPage = res.total
    //   }
    //   this.setState({
    //     currenrtPage,
    //     historyInfo,
    //     totalPage
    //   })
    // })
  }
  handleScroll = event => {
    let scrollHeight = event.target.scrollHeight,
        scrollTop = event.target.scrollTop,
        offsetHeight = event.target.offsetHeight;
    if(scrollTop>0){
      this.fixedTopDom.classList.add('fixed')
    }else{
      this.fixedTopDom.classList.remove('fixed')
    }
    let { currenrtPage,totalPage } = this.state
    if( currenrtPage >= totalPage)return 
    if(scrollHeight < scrollTop + offsetHeight + 28 || scrollHeight == scrollTop + offsetHeight ){
      this.getMoreLog()
    }
  }
  render(){
    let { busiObjName,busiObjCode } = this.props;
    let { pannel,showSingleJsonViewer,singleJsonIndex,showJsonViewer,historyInfo,compareIndex,currenrtPage,totalPage,isLoading } = this.state 
    let activeCompareBtn = compareIndex.length == 2;//激活对比操作按钮
    historyInfo = historyInfo.slice(0,currenrtPage * LOG_NUM_PAGE);//控制加载页数
    let logTree = historyInfo.map((v,k) => {
      let tempDate = transferDate(v.operationDate,'type-').split(' ')
      let yearDate = tempDate[0];
      let timeDate = tempDate[1];
      let choosed = compareIndex.indexOf(k) > -1
      let domStyle = v.operCode == 'insert'?'dom2':v.operCode == 'delete'?'dom3':'dom1'
      let isCurrentItem = v.operationDate == this.props.currentTime
      return (
        <div key={k} className={logItemWrap}>
          <div className={`${logItem} ${isCurrentItem?'current':''}`}>
            <div className="dateWrap">
              <span>{yearDate}</span>
              <span>{timeDate}</span>
            </div>
            <div className={domStyle}></div>
            <div onClick={this.expandContent} className={k==historyInfo.length-1?'end':''}>
              <span>{v.operatorName}</span><span onClick={this.chooseToSpread.bind(null,k)}>{historyLogLang.template("P_YS_PF_GZTLOG_0000080576") /* "查看数据" */}</span>
              <span>{v.differentMsg && v.differentMsg.replace("()",'')|| v.detail && v.detail.replace('()','') || ''}</span>
            </div>
            <div className={choosed?'active':''}  onClick={this.chooseToCompare.bind(null,k)}>
              <Checkbox color='primary' checked={choosed} onChange={this.chooseToCompare.bind(null,k)} ></Checkbox>
              <span>{historyLogLang.template("P_YS_HR_HRRCPDF_0000058793") /* "对比" */}</span>
            </div>
          </div>
        </div>
      )
    })
    //生成被比较的两个json对象(时间戳在后的始终在右侧)
    let leftJson = {},rightJson = {},leftTitle={},rightTitle={};
    function createTitle(record){
      return {
        time:transferDate(typeof record.operationDate == 'string' ? record.operationDate : Number(record.operationDate),'type-'),
        name:record.operatorName
      }
    }
    if(compareIndex.length == 2){
      //在historyInfo中 时间戳大的总是先出现( 调整至index1<index2 即 index1对应的时间戳大于index2的 作为rightJson )
      let [ index1,index2 ] = compareIndex.concat().sort((a,b)=>a-b);
      // 处理属性名为 null 的情况；
      leftJson = JSON.parse(historyInfo[index2].newBusiObj.replace(/null:/g, '"null":')||JSON.stringify({}))
      rightJson = JSON.parse(historyInfo[index1].newBusiObj.replace(/null:/g, '"null":')||JSON.stringify({}))
      leftTitle = createTitle(historyInfo[index2])
      rightTitle = createTitle(historyInfo[index1])
    }
    let singleTitle = {},singleJson = {};
    if(showSingleJsonViewer){
      let index = singleJsonIndex;
      // 处理属性名为 null 的情况；
      let newBusiObj = historyInfo[index].newBusiObj && historyInfo[index].newBusiObj.replace(/null:/g, '"null":');
      singleJson =  JSON.parse( newBusiObj || JSON.stringify({})) 
      singleTitle = createTitle(historyInfo[index])
    }

    return (  
      <Modal
        className={modalWrap}
        show = { pannel }
        onHide = { this.close }
        backdropStyle={{opacity:'0.4'}}
        backdrop={true} >
          <Modal.Header closeButton>
              <Modal.Title>
              {historyLogLang.template("P_YS_PF_GZTLOG_0000083156") /* "业务历史变更" */}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={pannelWrap}>
              <div className={logHistoryWrap}>
                <div ref={node=>this.fixedTopDom = node} className={isLoading||logTree.length<=0?'operWrap fixed':'operWrap'}>
                  <span>{busiObjName || busiObjCode|| ''}</span>
                  {!isLoading&&logTree.length>0?<button className={activeCompareBtn?'active':''} disabled={!activeCompareBtn} onClick={this.togglePannel}>{historyLogLang.template("P_YS_PF_GZTLOG_0000083158") /* "对比操作" */}</button>:null}
                </div>
                <div className='fixedWrap' onScroll={this.handleScroll}>
                  {
                    !isLoading&&logTree.length>0?
                      logTree:
                      isLoading?
                        <div className="loading">
                          <Loading />
                        </div>:
                        <div className="no-log-img" style={{backgroundImage:`url(${noLog})`}}></div>
                  }
                </div>
                <div className='footer'>
                  <button onClick={this.close}>{historyLogLang.template("P_YS_PF_GZTLOG_0001068839") /* "关闭" */}</button>
                </div>
              </div>
              <Modal
                className={`${modalWrap} expand`}
                show = { showJsonViewer || showSingleJsonViewer }
                onHide = { this.close }
                backdropStyle={{opacity:'0.4'}}
                backdrop={true} >
                  <Modal.Header closeButton>
                      <Modal.Title>
                        {
                          !showSingleJsonViewer?
                          historyLogLang.template("P_YS_PF_GZTLOG_0000083158") /* "对比操作" */:
                          historyLogLang.template("P_YS_PF_GZTLOG_0000083159") /* "详细数据" */
                        }
                      </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className={pannelWrap}>
                      <div className={jsonViewerWrap}>
                        <div style={{"width":'100%','height':'100%'}} >
                        {
                          !showSingleJsonViewer?
                          <JsonViewer leftTitle={leftTitle} jsonDataLeft={leftJson} rightTitle={rightTitle} jsonDataRight={rightJson} />:
                          <SingleJsonViewer title={singleTitle} jsonData={singleJson} />
                        }
                        </div>
                      </div>
                      <div className='example'>
                      {
                        !showSingleJsonViewer?
                        <div>
                          <span>{historyLogLang.template("P_YS_FED_EXAMP_0000019871") /* "删除" */}</span>
                          <span>{historyLogLang.template("P_YS_FED_FW_0000021020") /* "新增" */}</span>
                          <span>{historyLogLang.template("P_YS_FED_FW_0000022188") /* "更新" */}</span>
                        </div>:<p>{JSON.stringify(singleJson) == '{}'?historyLogLang.template("P_YS_PF_GZTLOG_0000080579") /* "没有详细数据，请检查元数据上是否设置标签" */:''}</p>
                      }
                        <button onClick={this.close}>{historyLogLang.template("P_YS_PF_GZTLOG_0001068839") /* "关闭" */}</button>
                      </div>
                    </div>
                  </Modal.Body>
              </Modal>
            </div>
          </Modal.Body>
      </Modal>
    )   
  }
}



// WEBPACK FOOTER //
// ./src/components/zHistoryLog/index.js